import React, { useState } from "react";
import Logo from "/static/logo.svg";
import FooterSection from "./FooterSection";
import FixedCta from "./FixedCta";

const Footer = ({ settings }) => {
  const navData = settings.content.footer_navigation.map((item) => {
    return {
      ...item,
      open: false,
    };
  });

  const [data, setData] = useState(navData);

  const handleClick = (_uid) => {
    setData((data) =>
      data.map((item) => {
        return {
          ...item,
          open: _uid === item._uid ? !item.open : false,
        };
      })
    );
  };

  return (
    <footer className="bg-darkgrey bg-cover bg-no-repeat bg-center">
      <div className="flex flex-wrap max-w-7xl mx-auto pt-12 pb-8 lg:pt-20 lg:pb-14 overflow-hidden px-6">
        <div className="w-full md:w-4/12 lg:w-3/12 pr-6">
          <img className="mb-8" src={Logo} alt="TLF Research" />
          <p className="text-white text-xs leading-5 font-body max-w-sm mb-4">
            Sign up and receive a monthly collection of interesting articles and
            opinion pieces on a range of customer experience and research
            topics.
          </p>
          <a
            className="cursor-pointer inline-flex justify-center items-center px-[30px] py-[14px] line-crop font-display tracking-normal text-white uppercase transition duration-300 text-[1.3rem] !leading-tight bg-red hover:bg-darkred"
            href="/newsletter-sign-up"
          >
            Sign up to CX Insights
          </a>
        </div>
        <div className="w-full md:w-6/12 lg:w-5/12 flex flex-col lg:flex-row flex-wrap md:ml-auto">
          <div className="w-full flex flex-col md:flex-row flex-wrap my-6 lg:my-0">
            {data.map((item) => (
              <div className="lg:ml-auto lg:w-auto w-full md:w-1/2" key={item._uid}>
                <FooterSection {...item} onClick={handleClick} />
              </div>
            ))}
          </div>
        </div>
        <div className="w-full lg:w-4/12 flex flex-col md:flex-row flex-wrap">
          <div className="w-full flex flex-col lg:flex-row flex-wrap my-6 lg:my-0">
            <div className="relative lg:ml-auto font-display uppercase max-w-[181px]">
              <div className="text-lg leading-[1.2rem]">
                <p className="text-white">
                  Taylor Hill Mill, Huddersfield, West Yorkshire HD4 6JA
                </p>
                <p className="text-white mt-4">
                  T:{" "}
                  <a
                    className="transition duration-300 hover:text-red"
                    href="tel:01484517575"
                  >
                    01484 517 575
                  </a>
                </p>
                <p className="text-white">
                  E:{" "}
                  <a
                    className="transition duration-300 hover:text-red"
                    href="mailto:UK@LEADERSHIPFACTOR.COM"
                  >
                    uk@leadershipfactor.com
                  </a>
                </p>
              </div>
              <div className="relative mt-5 lg:absolute lg:bottom-0">
                <a
                  className="text-white transition duration-300 hover:text-red mr-3"
                  href="https://twitter.com/TLFResearch"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-twitter fa-lg"></i>
                </a>
                <a
                  className="text-white transition duration-300 hover:text-red"
                  href="https://www.linkedin.com/groups?home=&amp;gid=2140154"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-linkedin-in fa-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-darkgrey">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap flex-col lg:flex-row max-w-7xl mx-auto py-6 text-grey text-xxs font-body tracking-normal border-t border-lightgrey">
            <p className="mb-2 lg:mb-0">
              &copy; TLF Research Ltd 2021. All Rights Reserved.
            </p>
            <p className="lg:ml-auto">
              Website by{" "}
              <a
                className="font-bold text-white hover:text-red transition duration-300"
                href="https://www.thebiggerboat.co.uk"
                target="_blank"
                rel="noreferrer"
              >
                The Bigger Boat
              </a>
            </p>
          </div>
        </div>
      </div>
      <FixedCta />
    </footer>
  );
};

export default Footer;
